const DEFAULT_PROFILE_IMAGE = "/img/icons/UserFalse.svg";

const getUnreadCount = (contact = {}) => {
  const unreadCount = Number(
    contact.unreadCount ??
      contact.mensajesNoLeidos ??
      contact.noLeidos ??
      contact.notificaciones ??
      contact.unread ??
      0,
  );

  return Number.isFinite(unreadCount) ? unreadCount : 0;
};

const getArchivedFlag = (contact = {}) =>
  Boolean(contact.isArchived ?? contact.archivado ?? false);

const getReadFlag = (contact = {}) => {
  if (typeof contact.isRead === "boolean") return contact.isRead;
  if (typeof contact.leido === "boolean") return contact.leido;
  return getUnreadCount(contact) === 0;
};

export const buildConversationState = (contact = {}) => {
  const unreadCount = getUnreadCount(contact);
  const isArchived = getArchivedFlag(contact);
  const isRead = getReadFlag(contact) && unreadCount === 0;

  return {
    unreadCount,
    isArchived,
    isRead,
    status: isArchived ? "archived" : unreadCount > 0 ? "unread" : "read",
  };
};

const getCanSendMessage = (contact = {}) => {
  const value =
    contact.puedeMandarMensaje ??
    contact.PuedeMandarMensaje ??
    contact.puedeVer ??
    contact.PuedeVer;

  return value === false ? false : true;
};

export const mapChatConversationPreview = (contact = {}) => ({
  idChat: contact.idChat ?? contact.IdChat ?? null,
  id: contact.idUsuarioOrigen ?? contact.idUsuario ?? contact.id ?? null,
  lastMessageId:
    contact.idMensaje ??
    contact.idMessage ??
    contact.messageId ??
    contact.idUltimoMensaje ??
    null,
  name: contact.nombre ?? contact.name ?? contact.nombres ?? "",
  avatar: contact.fotoPerfilUrl ?? null,
  fotoPerfilUrl: contact.fotoPerfilUrl ?? null,
  lastMessage: contact.mensaje ?? contact.lastMessage ?? "",
  timestamp: contact.fechaEnvio ?? contact.timestamp ?? null,
  idNacionalidad: contact.idNacionalidad,
  nickName: contact.nickName,
  estatus: contact.estatus,
  puedeVer: getCanSendMessage(contact),
  puedeMandarMensaje: getCanSendMessage(contact),
  privacidadMensaje: contact.privacidadMensaje ?? contact.PrivacidadMensaje ?? null,
  privacidadTexto: contact.privacidadTexto ?? contact.PrivacidadTexto ?? null,
  ...buildConversationState(contact),
});

export const normalizeSelectedChatUser = (entity = {}) => {
  const [nombres, ...rest] = (
    entity.nombre ??
    entity.name ??
    entity.nombres ??
    ""
  ).split(" ");

  return {
    idChat: entity.idChat ?? entity.IdChat ?? null,
    idUsuario: entity.id ?? entity.idUsuario ?? entity.idUsuarioOrigen,
    nombres,
    apellidos: rest.join(" ") || entity.apellidos,
    profPic: entity.fotoPerfilUrl ?? entity.avatar ?? DEFAULT_PROFILE_IMAGE,
    idNacionalidad: entity.idNacionalidad,
    nickName: entity.nickName,
    estatus: entity.estatus,
    puedeVer: getCanSendMessage(entity),
    puedeMandarMensaje: getCanSendMessage(entity),
    privacidadMensaje: entity.privacidadMensaje ?? entity.PrivacidadMensaje ?? null,
    privacidadTexto: entity.privacidadTexto ?? entity.PrivacidadTexto ?? null,
  };
};
